
// worldcoin.org / world.org mini-app links, with or without the slash before "?".
const MINI_APP_LINK = /^https?:\/\/(?:worldcoin|world)\.org\/mini-app\/?\?/;
/** Rewrites a worldcoin.org / world.org mini-app link into a `worldapp://` deep link that opens in its own window; anything else is returned unchanged. */
export function formatMiniAppLink(url: string): string {
  if (!MINI_APP_LINK.test(url)) return url;
  try {
    const params = new URL(url).searchParams;
    const appId = params.get("app_id");
    if (!appId) return url;
    const path = params.get("path");
    const pathParam = path ? `&path=${encodeURIComponent(path)}` : "";
    return `worldapp://mini-app?app_id=${appId}${pathParam}&open_out_of_window=true`;
  } catch {
    return url;
  }
}